
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15 18.5C12.49 18.5 10.32 17.08 9.23995 15H14.38C14.76 15 15.11 14.79 15.27 14.45C15.6 13.79 15.12 13 14.38 13H8.57995C8.52995 12.67 8.49995 12.34 8.49995 12C8.49995 11.66 8.52995 11.33 8.57995 11H14.38C14.76 11 15.11 10.79 15.27 10.45C15.61 9.78 15.13 9 14.38 9H9.23995C10.32 6.92 12.5 5.5 15 5.5C16.25 5.5 17.42 5.86 18.42 6.47C18.92 6.78 19.57 6.73 19.99 6.31C20.57 5.73 20.44 4.78 19.74 4.35C18.36 3.5 16.73 3 15 3C11.08 3 7.75995 5.51 6.51995 9H3.61995C3.23995 9 2.88995 9.21 2.71995 9.55C2.38995 10.22 2.86995 11 3.61995 11H6.05995C6.01995 11.33 5.99995 11.66 5.99995 12C5.99995 12.34 6.01995 12.67 6.05995 13H3.61995C3.23995 13 2.88995 13.21 2.72995 13.55C2.38995 14.22 2.86995 15 3.61995 15H6.51995C7.75995 18.49 11.08 21 15 21C16.74 21 18.36 20.51 19.74 19.65C20.43 19.22 20.56 18.26 19.98 17.68C19.56 17.26 18.91 17.21 18.41 17.53C17.42 18.15 16.26 18.5 15 18.5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-euro`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconEuro

    ```js
    <b-new-b-icon-euro />
    ```
</docs>


